module.exports = __webpack_public_path__ + "static/img/dlspos.e1eb807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/dlspos.png
// module id = ZTzP
// module chunks = 0